import { StringHelper } from "../helper/string-helper";
import { UrlHelper } from "../core/html/url-helper";

export class HeaderFavIconAnimationVm {
	public static initialize() {
		let headerFavicon = document.querySelector('[rel="shortcut icon"]');
		let headerCounter = 45;
		let headerCount = 2;
		let toggle = UrlHelper.getData("toggle", "#fav-icon-animation-path");
		let animationEnabled = UrlHelper.getBool("enabled", "#fav-icon-animation-path");
		let animationPath = (document.head.querySelector("meta[name='fav-icon-animation-path']") as any).content;

		let headerRotateIcon = setInterval(() => {
			if (animationEnabled) {
				headerCounter = headerCounter + headerCount;
				if (headerCounter > 89 && headerCount > 0) {
					headerCount = headerCount * -1;
				}
				else if (headerCounter < 0 && headerCount < 0) {
					headerCount = headerCount * -1;
				}
			}

			if (animationPath) {
				let oldHref = (headerFavicon as any).href;
				let newHref = animationPath.replace("{0}", headerCounter);

				newHref = document.hidden ? newHref.replace("{1}", toggle) : newHref.replace("{1}", "");
				if (oldHref !== newHref) {
					(headerFavicon as any).href = newHref;
				}
			}
		}, 100);
	}
}